
    import './styles.scoped.css';
    export default {
  "selectable-item": "awsui_selectable-item_15o6u_1z0on_9",
  "parent": "awsui_parent_15o6u_1z0on_28",
  "interactiveGroups": "awsui_interactiveGroups_15o6u_1z0on_28",
  "highlighted": "awsui_highlighted_15o6u_1z0on_28",
  "selected": "awsui_selected_15o6u_1z0on_28",
  "selectable-item-content": "awsui_selectable-item-content_15o6u_1z0on_31",
  "pad-bottom": "awsui_pad-bottom_15o6u_1z0on_35",
  "virtual": "awsui_virtual_15o6u_1z0on_42",
  "has-background": "awsui_has-background_15o6u_1z0on_45",
  "child": "awsui_child_15o6u_1z0on_48",
  "disabled": "awsui_disabled_15o6u_1z0on_54",
  "is-keyboard": "awsui_is-keyboard_15o6u_1z0on_73",
  "visual-refresh": "awsui_visual-refresh_15o6u_1z0on_83",
  "next-item-selected": "awsui_next-item-selected_15o6u_1z0on_97",
  "previous-item-selected": "awsui_previous-item-selected_15o6u_1z0on_107",
  "sticky": "awsui_sticky_15o6u_1z0on_139",
  "with-scrollbar": "awsui_with-scrollbar_15o6u_1z0on_158",
  "after-header": "awsui_after-header_15o6u_1z0on_161",
  "measure-strut": "awsui_measure-strut_15o6u_1z0on_190",
  "screenreader-content": "awsui_screenreader-content_15o6u_1z0on_202",
  "option-content": "awsui_option-content_15o6u_1z0on_208",
  "select-all": "awsui_select-all_15o6u_1z0on_212"
};
  